import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Comment from '../../Comment';
import styles from './index.css';
import { getList, addReplyUser } from '../../utils';
import LoadingMore from '@src/mobile/components/LoadingMore';
import ReplyBtn from '../../ReplyBtn';
import { Store } from '../../store';
import { POSITION_SUB, POSITION_SUB_TOP } from '../../constants';

const List = ({ onClose }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { list, replyLisRootId, replyList, replyPage, docMeta } = states;

    const topIndex = list.findIndex(item => item.id === replyLisRootId);
    const topItem = list[topIndex];
    const { subjectId, id } = topItem;

    const control = async () => {
        let statusText = 'error';
        let _page = replyPage;
        let _comments = [];
        let _loop = false;

        do {
            // 获取分页评论列表
            const res = await getList({
                subjectId,
                page: _page,
                rootId: id,
                sort: { key: 'createTime', type: 'asc' },
                docUrl: docMeta?.docUrl,
            });
            const { current, pageSize, total } = res;

            _comments = res.list;

            if (_comments && Array.isArray(_comments) && _comments.length) {
                // 去重
                _comments = _comments.filter(item => !replyList.find(comment => comment.id === item.id));
            }

            if (current * pageSize >= total) {
                statusText = 'end';
            } else {
                statusText = 'success';
            }

            _loop = _comments.length <= 0 && statusText === 'success';

            if (_loop) {
                _page += 1;
            }
        } while (_loop);

        const newComments = [...replyList, ..._comments];
        const newPage = _page + 1;

        addReplyUser(newComments);
        changeStates({ replyList: newComments, replyPage: newPage });

        return statusText;
    };

    useEffect(
        () => {
            // 弹窗销毁前，要把分页加载的数据清除
            const newList = [...list];

            newList[topIndex] = { ...topItem, comments: replyList.slice(0, 2) };

            changeStates({ list: newList });
        },
        [replyList],
    );

    return (
        <div className={styles.content}>
            <div className={styles.header}>
                <div className={styles.close} onClick={onClose} />
                <div className={styles.title}>评论详情</div>
            </div>
            <div className={styles.main}>
                <div className={styles.mainCenter}>
                    <div className={styles.top}>
                        <Comment content={topItem} position={POSITION_SUB_TOP} />
                    </div>
                    <div className={styles.listTitle}>全部回复</div>
                    <div>{replyList.map(item => <Comment key={item.id} content={item} position={POSITION_SUB} />)}</div>
                    <LoadingMore control={control} />
                    <ReplyBtn subjectId={subjectId} commentId={id} />
                </div>
            </div>
        </div>
    );
};

List.propTypes = {
    onClose: PropTypes.func,
};

export default errorBoundary(List);
